import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div(
  ({theme}) => css`
    box-sizing: border-box;

    ${theme.respondUpTo(
      'md',
      css`
        padding: 0 16px 16px;
      `
    )}

    ${theme.respondTo(
      'md',
      css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 16px 16px 16px 0;
      `
    )}
  `
);
